export default {
  detail: [
    {
      text: 'nombre',
      value: 'name',
    },
    {
      text: 'precio costo',
      value: 'cost_price',
      format: 'currency',
      input: {
        type: 'currency-field',
        reverse: true,
        trigger: gains_margin_trigger,
      },
      align: 'right',
    },
    {
      text: 'precio venta',
      value: 'sale_price',
      format: 'currency',
      input: {
        type: 'currency-field',
        reverse: true,
        trigger: gains_margin_trigger,
      },
      align: 'right',
    },
    {
      text: 'margen',
      value: 'gains_margin',
      format: 'percentage',
      align: 'right',
    },
    {
      text: 'stock máximo',
      value: 'maximum_stock',
      format: 'number',
      input: {
        type: 'float-field',
        reverse: true,
      },
      align: 'right',
    },
    {
      text: 'stock mínimo',
      value: 'minimum_stock',
      format: 'number',
      input: {
        type: 'float-field',
        reverse: true,
      },
      align: 'right',
    },
    {
      text: 'stock critico',
      value: 'critical_stock',
      format: 'number',
      input: {
        type: 'float-field',
        reverse: true,
      },
      align: 'right',
    },
  ],
  list: [
    {
      text: '#',
      value: 'id',
      width: '10%',
    },
    {
      text: 'codigo interno',
      value: 'internal_code',
      width: '10%',
    },
    {
      text: 'nombre',
      value: 'name',
      width: '55%',
    },
    {
      text: 'cantidad',
      value: 'wh_pack_item_quantity',
      align: 'right',
      width: '10%',
    },
    {
      text: 'modificado',
      value: 'updated_at',
      align: 'right',
      format: 'datetime',
      width: '15%',
    },
  ],
} 

/**
 * 
 */
function gains_margin_trigger(ctx, props) {
  //
  const { cost_price, sale_price } = props.item
  const gain_price = sale_price - cost_price
  //
  props.item.gains_margin = Math.max(Math.round((gain_price / cost_price) * 100), 0)
}
